import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Logo } from "@/components/Logo";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await register(name, email, password);
      navigate("/dashboard");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Registration failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-brand-bg flex items-center justify-center px-6 py-12">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-8"><Logo /></div>
        <div className="bg-white border border-brand/10 rounded-sm p-8 shadow-sm">
          <h1 className="font-display text-3xl text-brand text-center">Create your account</h1>
          <p className="text-sm text-brand-muted text-center mt-1">Order organic inputs & track deliveries</p>

          <form onSubmit={submit} className="mt-7 space-y-4">
            <div>
              <Label htmlFor="name" className="text-brand">Full name</Label>
              <Input id="name" data-testid="register-name" required value={name} onChange={(e) => setName(e.target.value)} className="mt-1.5 h-12 rounded-sm" placeholder="Kwame Mensah" />
            </div>
            <div>
              <Label htmlFor="email" className="text-brand">Email</Label>
              <Input id="email" data-testid="register-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5 h-12 rounded-sm" placeholder="you@example.com" />
            </div>
            <div>
              <Label htmlFor="password" className="text-brand">Password</Label>
              <Input id="password" data-testid="register-password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5 h-12 rounded-sm" placeholder="At least 6 characters" />
            </div>
            {error && <p className="text-sm text-brand-terracotta" data-testid="register-error">{error}</p>}
            <Button type="submit" data-testid="register-submit" disabled={loading} className="w-full h-12 bg-brand hover:bg-brand-hover text-white rounded-full">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Create Account"}
            </Button>
          </form>

          <p className="text-sm text-brand-muted text-center mt-6">
            Already have an account? <Link to="/login" data-testid="go-login" className="text-brand font-medium hover:underline">Sign in</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
